export default {
	label: 'Moodul | Moodulid',
	related: 'Seotud moodul',
	responsiblesForAssets: 'Mooduli vastutajad varadele',
	responsibleInfoTooltip:
		'Kui varale tuleb määrata mooduli sees muu vastutaja, siis "Mooduli vastutajad varadele" nimekirjas saab seda teha mooduliga seotud varade kaupa.',
	noConnectedAssets: 'Seotud varad puuduvad',
	connectAssetHint: 'Siduge vara mooduliga',
	associationName: 'Seose nimetus',
	overwriteText: 'Kas soovite valitud mooduli meetmete vastutajad üle kirjutada?',
	replaceText: 'Vajutades "Asenda määramata" nuppu, määratakse mooduli vastutaja ainult meetmetele, millel ei ole olemasolevat vastutajat.',
	replaceUnassigned: 'Asenda määramata',
	replaceAll: 'Asenda kõik',
	type: 'Tüüp',
	systemModule: 'Süsteemimoodul',
	processModule: 'Protsessimoodul',
	addModule: 'Lisa moodul',
	editModule: 'Muuda moodulit',
	status: {
		label: 'Staatus',
		applicable: 'Rakendub',
		inapplicable: 'Ei rakendu',
		excluded: 'Välja lülitatud',
	},
	search: 'Otsi moodulit',
	stats: 'Meetme staatused',
}
